module.exports = __webpack_public_path__ + "img/call-1.5fc8a645.svg";